import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[inputMask]',
})
export class InputMaskDirective {
    @Input() mask: string = '';

    // eslint-disable-next-line @angular-eslint/prefer-inject
    constructor(private el: ElementRef) {}

    @HostListener('input', ['$event'])
    onInput(event: Event) {
        const input = event.target as HTMLInputElement;
        // eslint-disable-next-line prefer-const
        const value = input.value.replace(/\D/g, '');
        let result = '';
        let valueIndex = 0;

        for (let i = 0; i < this.mask.length && valueIndex < value.length; i++) {
            if (this.mask[i] === '0') {
                result += value[valueIndex];
                valueIndex++;
            } else {
                result += this.mask[i];
            }
        }

        input.value = result;
    }
} 